module.exports = __webpack_public_path__ + "static/media/JD.cfd1f098.jpg";